import { gql } from "@apollo/client";

export const SAVE_CLIP_MUTATION = gql`
  mutation SaveClip($clipId: String!) {
    saveClip(clipId: $clipId) {
      success
      savedCount
      limit
      errors {
        field
        code
        message
      }
    }
  }
`;

export const UNSAVE_CLIP_MUTATION = gql`
  mutation UnsaveClip($clipId: String!) {
    unsaveClip(clipId: $clipId) {
      success
      savedCount
      limit
      errors {
        field
        code
        message
      }
    }
  }
`;
